import React from "react";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import LTVReportInvoiceTable from "../table/all-tables/reportable/ltvreport/invoice/LTVReportInvoiceTable";
import { ltvReport, buttonName } from "../../locales/en";
import CommonModal from "./CommonModal";

const LTVReportInvoiceModal = ({ isOpen, toggle, invoiceDetails }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={ltvReport?.invModal?.title}
      modalClassName="modal-fullscreen w-100 h-auto"
      bodyClassName={Modalstyle.refMonthlySingleContent}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: () => toggle(false)
        }
      ]}
    >
      <LTVReportInvoiceTable invoiceDetails={invoiceDetails} />
    </CommonModal>
  );
};

LTVReportInvoiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  invoiceDetails: PropTypes.array
};

export default LTVReportInvoiceModal;
